import { Vue } from 'nuxt-property-decorator';

// Iterate through parents, until we find the correct match from componentName
export default function findParentComponentByName(
  componentName: string,
  vueElm: Vue,
  componentName2?: string
): Vue | null {
  let component: Vue | null = null;
  let parent = vueElm.$parent;

  if (componentName2)
    while (parent && !component) {
      if (
        parent.$options.name === componentName ||
        parent.$options.name === componentName2
      ) {
        component = parent;
      }

      parent = parent.$parent;
    }
  else {
    while (parent && !component) {
      if (parent.$options.name === componentName) {
        component = parent;
      }

      parent = parent.$parent;
    }
  }

  return component;
}
